<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :colonneWidth="colonneWidth" :GetFunction="fetchCompanies">
        <template v-slot:[SlotsFilters.Filter0]="{ index }">
            <ColumnFilter :title="$t('Delivery.companyName')" :Filter="filters.SearchName" :getList="fetchCompanies"
                @cancel="filters.SearchName = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchName" id="companyName" variant="outlined" maxlength="50"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>
        
        <template v-slot:[SlotsFilters.Filter1]="{ index }">
            <ColumnFilter :title="$t('Delivery.email')" :Filter="filters.SearchEmail" :getList="fetchCompanies"
                @cancel="filters.SearchEmail = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchEmail" id="email" variant="outlined" maxlength="50"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter2]="{ index }">
            <ColumnFilter :title="$t('Delivery.Created')" :Filter="filters.CreationDate" :getList="fetchCompanies"
                @cancel="filters.CreationDate = null" :index="index">
                <template v-slot:input>
                    <dateField v-model="filters.CreationDate" :min-date="new Date('2000-01-01')"
                        :max-date="new Date()" />
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter3]="{ index }">
            <ColumnFilter :title="$t('Delivery.Address')" :Filter="filters.SearchAddress" :getList="fetchCompanies"
                @cancel="filters.SearchAddress = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchAddress" id="address" variant="outlined" maxlength="100"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter4]="{ index }">
            <ColumnFilter :title="$t('Delivery.status')" :Filter="filters.IsActive" :getList="fetchCompanies"
                @cancel="filters.IsActive = null" :index="index">
                <template v-slot:input>
                    <v-select v-model="filters.IsActive" :items="[
                        { title: 'Active', value: true },
                        { title: 'Inactive', value: false }
                    ]" item-title="title" item-value="value" variant="outlined" hide-details></v-select>

                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.name }}</template>
        <template v-slot:[SlotsItems.item1]="{ item }">{{ item.email }}</template>
        <template v-slot:[SlotsItems.item2]="{ item }">{{ item.creationDate.split('T')[0] }}</template>
        <template v-slot:[SlotsItems.item3]="{ item }">{{ item.address }}</template>
        <template v-slot:[SlotsItems.item4]="{ item }">
            <StatusButton :title="getStatusLabel(item.isActive)" :color="getStatusColor(item.isActive)" />
        </template>
        <template v-slot:edit="{ item }">
            <DelvriesActionMenu :Id="item.deliveryCompanyId" :idBrand="item.deliveryCompanyId"
                :getBrandListAfterDelete="fetchCompanies" :status="item.isActive" />
        </template>
    </gridComponent>
</template>


<script>
import GridComponent from '@/genericComponent/gridComponent.vue';
import ColumnFilter from '@/genericComponent/ColumnFilter.vue';
import DateField from '@/genericComponent/date-field.vue';
import StatusButton from '@/genericComponent/StatusButton.vue';
import DelvriesActionMenu from './DelvriesActionMenu.vue'
import { getCompanies } from "@/api/index";
export default {
    components: { StatusButton, GridComponent, ColumnFilter, DateField, DelvriesActionMenu },
    props: {
        showFilterDialog: Boolean,

    },
    mounted() {
        this.fetchDeliveries(this.page);
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
            this.BrandsList();
        });
        this.dialogFilterclientsRef = this.$refs.dialogFilterclients;
    },
    unmounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
    },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            items: {},
            itemsData: {},
            filters: {
                SearchName: null,
                SearchEmail: null,
                SearchPhone: null,
                SearchAddress: null,
                SearchTaxIdentificationNumber: null,
                IsActive: null,
                CreationDate: null,
            },
            search: null,
            filterMenuitems: [1, 3, 4],
            brandName: null,
            FieldCategoryId: [],
            FieldCreatedDateFrom: null,
            FieldCreatedDateTo: null,
            FieldSupplierId: null,
            SortedBy: null,
            SortingType: null,
            localShowFilterDialog: this.showFilterDialog,
            MySupplier: null,
            item: null,
            suppliers: [],
            categories: [],
        }
    },
    methods: {
        fetchDeliveries(page) {
            if (page) this.page = page;
        },

        fetchCompanies: function (page) {
            this.page = page ? page : 1;
            this.loader = true;

            const newFilters = {
                SortedBy: this.SortedBy,
                SortingType: this.SortingType,
                SearchTerm: this.filters.SearchTerm,
                SearchName: this.filters.SearchName,
                SearchEmail: this.filters.SearchEmail,
                SearchPhone: this.filters.SearchPhone,
                SearchAddress: this.filters.SearchAddress,
                SearchTaxIdentificationNumber: this.filters.SearchTaxIdentificationNumber,
                IsActive: this.filters.IsActive,
                CreationDate: this.filters.CreationDate
            };
            getCompanies(this.page, this.PageSize, newFilters)
                .then((response) => {
                    this.items = response.data.items;
                    this.itemsData.numberOfPage = response.data.totalPages;
                    this.itemsData.totalItemsCount = response.data.totalCount;
                    this.itemsData.pageNumber = response.data.pageNumber;
                    this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                    this.itemsData.hasNextPage = response.data.hasNextPage;
                    this.loader = false;
                })
                .catch((error) => {
                    console.error("Error fetching companies:", error);
                    this.loader = false;
                });
        },


        getStatusLabel(isActif) {
            return isActif ? this.$t('common.active') : this.$t('common.inactive');
        },
        getStatusColor(isActif) {
            return isActif ? '#3BBAFF' : '#F25C5C';
        },



        handleCancel() {
            this.localShowFilterDialog = false;
        },
        handleConfirm(filteredParams) {
            this.brandName = filteredParams.BrandName;
            this.FieldCategoryId = filteredParams.IdCategories;
            this.FieldSupplierId = filteredParams.supplierId;
            this.FieldCreatedDateFrom = filteredParams.CreatedFrom;
            this.FieldCreatedDateTo = filteredParams.CreatedTo;
            this.BrandsList();
            this.localShowFilterDialog = false;
        },
    },
    watch: {
        showFilterDialog(value) {
            this.localShowFilterDialog = value;
        },
    },
    computed: {
        flattenedCategories() {
            const flatten = (cats, parentId = null, level = 0) => {
                return cats.reduce((acc, category) => {
                    if (category.parent_category_id === parentId) {
                        const flatCategory = {
                            ...category,
                            name: "  ".repeat(level) + category.name,
                        };
                        acc.push(flatCategory);
                        acc.push(...flatten(cats, category.categoryId, level + 1));
                    }
                    return acc;
                }, []);
            };
            return flatten(this.categories);
        },
        headers() {
            const headers = [
                this.$t('Delivery.companyName'),
                this.$t('Delivery.email'),
                this.$t('Brands.Created'),
                this.$t('Delivery.State'),
                this.$t('Delivery.status')

            ];
            return headers;
        },
        SlotsItems() {
            const items = {
                item0: 'item',
                item1: 'item',
                item2: 'item',
                item3: 'item',
                item4: 'item',
                item5: 'item',
            }
            let i = 0;
            for (const key in items) {
                items[key] = 'item' + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: 'Filter',
                Filter1: 'Filter',
                Filter2: 'Filter',
                Filter3: 'Filter',
                Filter4: 'Filter',
                Filter5: 'Filter',
            }
            let i = 0;
            for (const key in filters) {
                filters[key] = 'Filter' + i;
                i = i + 1;
            }
            return filters;
        },
        colonneWidth() {
            const headers = ['20%', '15%', '15%', '20%', '15%', '10%', '15%'];
            return headers;
        },

    }
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-window .v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.slider {
    color: #667280;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    pointer-events: none;
    border: none;
}
</style>
